<template>
  <Modal name="report">
    <main class="year-report">
      <header>
        <h1>{{ $t('Newsflash from global') }}</h1>
        <span class="year">{{ report.year.display }}</span>
      </header>

      <div class="body">
        <article v-html="report.message"></article>
      </div>
    </main>
  </Modal>
</template>

<script lang="ts" setup>
import { useStorage } from '@vueuse/core'
import { computed, ref, watchEffect } from 'vue'

import Modal from '/@front:components/Modal.vue'
import { useGameSession } from '/@front:composables/game-session'
import { useModal } from '/@front:composables/modal'
import { http } from '/@front:shared/http'
import { error } from '/@front:shared/notifications'

const { showModal } = useModal('report')
const { session, currentRound } = useGameSession()
const reportsSeen = useStorage<string[]>('reports-seen', [])

const report = ref<any>(undefined)

const reportRef = computed<string | undefined>(() => {
  if (!currentRound.value) {
    return
  }

  const currentYear = currentRound.value.year

  if (session.value.roundStatus.value === 'paused') {
    if (currentRound.value.isLastRoundOfYear) {
      return `y${currentYear.id}`
    }
  }

  if (currentYear.id === 1) {
    return
  }

  return `y${currentYear.id - 1}`
})

const fetchReport = () => {
  return http.get(session.value.links.yearReport)
}

watchEffect(() => {
  const key = reportRef.value
  if (!key) {
    return
  }

  if (reportsSeen.value.includes(key)) {
    return
  }

  fetchReport()
    .then((response) => {
      if (response.status === 204) {
        return
      }

      report.value = response.data

      showModal()
      reportsSeen.value.push(key)
    })
    .catch((err) => {
      if (err.response?.status === 401) {
        return
      }

      error('Could not load year report')
    })
})
</script>
